<template lang="pug">
  .header(
    :class="{bg_black: $route.path !== '/',fixed: scroll200}"
    )
    nav.navbar.navbar-landing-pc.navbar-client-pc.navbar-expand-lg.navbar-light.wak-navbar.d-flex.justify-content-between.app-container.w-md-auto
      router-link.navbar-brand(
        :to={name: 'home.index'})
        img(
          src="../../../assets/images/logo.svg"
          :alt="$t('header.logo')")

      .ml-auto
        router-link.text-white.mr-50(:to={name: 'usage.index'} v-if="!isAfter(date_now, show_twitter)")
          | {{$t('header.usage')}}
        router-link.text-white.mr-50(:to={name: 'streamer.index'})
          | {{$t('header.streamer')}}
        router-link.text-white.mr-50(:to={name: 'news.index'})
          | {{$t('header.news')}}
        router-link.text-white(:to={name: 'faq.index'})
          | {{$t('header.faq')}}

      .member-btn
        a(href="https://members.zatsudan.com/auth/login" target="_blank" class="menber-login")
         | ログイン
        a(href="https://members.zatsudan.com/auth/verify-email" target="_blank" class="menber-register")
         | アカウント登録

</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'header-client-pc',
    // 呼び出す
    computed: {
       ...mapGetters('layout', ['scroll200']),
    },
    data() {
      return {
        date_now: this.$moment().format(),
        show_twitter: this.$moment('2021-01-31T23:59:59+09:00').format(),
      }
    },
    methods: {
      isAfter(dateNow, endDate) {
        //console.log(this.$moment(dateNow))
        return this.$route.query.time ? this.$moment(this.$route.query.time).isAfter(endDate) : this.$moment(dateNow).isAfter(endDate)
      }
    },
  }
</script>
<style>
.bg_black{
  background-color: #000;
}
</style>
